import { ISearchSuggestionProps } from '@1js/search-box-hostapp-interface';
import React from 'react';

import { KnownReferralPlatform } from '../../shared/instrumentation/instrumentation.service';
import { FileItem } from '../../shared/models/file-item.model';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SharedSearchService } from '../shared-search.service';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';
import { SearchSuggestionCompoundButtonComponent } from './search-suggestion-components/search-suggestion-compoundButton.component';

interface FileProps extends ISearchSuggestionProps {
    readonly id: string;
    readonly fileType: string;
    readonly isLocal: boolean;
    readonly fileExtension: string;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly sharedSearchService: SharedSearchService;
    readonly webUrl: string;
    readonly title?: string;
    readonly secondaryDisplayText?: string;
    readonly iconClass?: string;
    readonly iconUrl?: string;
}

export class FileSearchSuggestionComponent extends React.Component<FileProps> {

    public static createFileTypeStringForNarrator: (fileType: string) => string;

    public readonly handleClick = (props: any, referral: string) => (e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault();
        this.props.sharedSearchService.setFilesAutosuggestClick(
                                        {
                                            ...props,
                                            customLoggingFunction:  this.logFileAutosuggestClick(referral),
                                            displayText: props.title + '.' + props.fileExtension,
                                            url: !props.isLocal && props.webUrl !== undefined ? props.webUrl : props.url,
                                            canonicalUrl: props.url,
                                            shortUrl: props.webUrl !== undefined ? true : false
                                        });
    }

    public render() {
        const fileType = FileItem.fileTypeFromExtension(this.props.fileExtension);
        const referral = FileItem.referralFromFileType(fileType);
        return (
            <SearchSuggestionCompoundButtonComponent
                title={this.props.title}
                description={this.props.secondaryDisplayText}
                icon={this.props.iconClass}
                isDarkMode={BaseSuggestionProvider.isDarkMode}
                isPwa={BaseSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp}
                fileTypeNarratorString={FileSearchSuggestionComponent.createFileTypeStringForNarrator(this.props.fileType) + ':'}
                handleClick={this.handleClick(this.props, referral)}
                target='_blank'/>
        );
    }

    private readonly logFileAutosuggestClick = (referral: string) => (success: boolean, knownReferralPlatform?: KnownReferralPlatform) => {
        if (success) {
            this.props.searchInstrumentationService.logSearchClickEvent(
                                                        SearchResultType.File,
                                                        SearchResultElementId.File,
                                                        true,
                                                        SearchResultType.File,
                                                        undefined,
                                                        referral,
                                                        undefined,
                                                        undefined,
                                                        knownReferralPlatform);
        }
    }
}
